const PageNotices = () => import('@/modules/zcfw/notices/PageNotices')
const PageNews = () => import('@/modules/zcfw/news/PageNews')
const PageActivity = () => import('@/modules/zcfw/activity/PageActivity')
const PageActivityQy = () => import('@/modules/zcfw/activity/PageActivityQy')
const PageActivityZt = () => import('@/modules/zcfw/activity/PageActivityZt')
const PageActivityGz = () => import('@/modules/zcfw/activity/PageActivityGz')
const PagePolicy = () => import('@/modules/zcfw/policy/PagePolicy')
const PageCompanyPolicy = () => import('@/modules/zcfw/common/PageCompanyPolicy')
const PageCollectInfo = () => import('@/modules/zcfw/collectInfo/PageCollectInfo')
const PageApply = () => import('@/modules/zcfw/apply/PageApply')
const PagePolicyInterpretation = () => import('@/modules/zcfw/policyInterpretation/PagePolicyInterpretation')
const PageFormView = () => import('@/modules/menu/PageFormView')
const PageChartView = () => import('@/modules/menu/PageChartView')
const PageActivityCheckin = () => import('@/modules/zcfw/activityCheckin/PageActivityCheckin')
const AiqichaDataClean = () => import('@/modules/aiqicha/DataClean')
const pushCxzcToSdpt = () => import('@/modules/cxsd/pushCxzcToSdpt')
const PagePolicyLabel = () => import('@/modules/zcfw/policyLabel/PagePolicyLabel')
const PagePushLog = () => import('@/modules/zcfw/pushLog/PagePushLog')

export default [
  {
    path: '/zcfw/activity',
    name: 'zcfwActivity',
    component: PageActivity,
    meta: {
      title: '双创活动',
    },
  },
  {
    path: '/zcfw/activityQy',
    name: 'zcfwActivityQy',
    component: PageActivityQy,
    meta: {
      title: '双创活动',
      isBlack: true
    },
  },
  {
    path: '/zcfw/activityGz',
    name: 'zcfwActivityGz',
    component: PageActivityGz,
    meta: {
      title: '我关注的载体活动',
      isBlack: true
    },
  },
  {
    path: '/zcfw/activityZt',
    name: 'zcfwActivityZt',
    component: PageActivityZt,
    meta: {
      title: '载体活动',
      isBlack: true
    },
  },
  {
    path: '/zcfw/notices',
    name: 'zcfwNotices',
    component: PageNotices,
    meta: {
      title: '通知公告',
      isBlack: true
    },
  },

  {
    path: '/zcfw/news',
    name: 'zcfwNews',
    component: PageNews,
    meta: {
      title: '热点新闻',
      isBlack: true
    },
  },
  {
    path: '/zcfw/policy',
    name: 'zcfwPolicy',
    component: PagePolicy,
    meta: {
      title: '最新政策',
      isBlack: true
    },
  },
  {
    path: '/zcfw/policyInterpretation',
    name: 'zcfwPolicyInterpretation',
    component: PagePolicyInterpretation,
    meta: {
      title: '政策解读',
      isBlack: true
    },
  },
  {
    path: '/zcfw/matching',
    name: 'matching',
    component: PageCompanyPolicy,
    meta: {
      title: '政策匹配',
      isBlack: true
    },
  },
  {
    path: '/zcfw/collectInfo',
    name: 'collectInfo',
    component: PageCollectInfo,
    meta: {
      title: '收藏管理',
      isBlack: true
    },
  },
  {
    path: '/zcfw/apply',
    name: 'apply',
    component: PageApply,
    meta: {
      title: '报名管理',
    },
  },
  {
    path: '/formView/:id',
    name: 'formView',
    component: PageFormView,
    meta: {
      title: '自定义表单',
    },
  },
  {
    path: '/chartView/:id',
    name: 'chartView',
    component: PageChartView,
    meta: {
      title: '自定义统计图',
    },
  },
  {
    path: '/zcfw/PageActivityCheckin',
    name: 'PageActivityCheckin',
    component: PageActivityCheckin,
    meta: {
      title: '自定义统计图',
      isBlack: true
    },
  },
  {
    path: '/AiqichaDataClean',
    name: 'AiqichaDataClean',
    component: AiqichaDataClean,
    meta: {
      title: '爱企查数据清洗',
      isBlack: true
    },
  },
  {
    path: '/pushCxzcToSdpt',
    name: 'pushCxzcToSdpt',
    component: pushCxzcToSdpt,
    meta: {
      title: '推送创新政策速兑内容给速兑平台',
      isBlack: true
    },
  },
  {
    path: '/policyLabel',
    name: 'policyLabel',
    component: PagePolicyLabel,
    meta: {
      title: '政策标签',
      isBlack: true
    },
  },
  {
    path: '/pushLog',
    name: 'pushLog',
    component: PagePushLog,
    meta: {
      title: '推送日志',
      isBlack: true
    },
  },
  {
    path: '/evaluation',
    name: 'evaluation',
    component: () => import('@/modules/zcfw/evaluation/EvaluationManager'),
    meta: {
      title: '满意度调查',
      isBlack: true
    },
  }
]
